<irb-common-overlay #overlayComponent></irb-common-overlay>

<div class="editor-side-bar-wrapper-narrow-width" #editorSideBarNarrowWidth>
  @if (template && !fullscreen) {
    <p-drawer [(visible)]="isSideBarVisible" class="irb-sidebar p-sidebar-narrow-width p-sidebar-tpl-{{template}}" position="right"
      [class]="{'align-top': fullscreen || slot == 'B' || slot == 'C'}" [modal]="isModal"
      [closeOnEscape]="false" [closable]="false" [baseZIndex]="999" [dismissible]="false" [appendTo]="editorSideBarNarrowWidth">
      <ng-container *ngTemplateOutlet="editors"></ng-container>
    </p-drawer>
  }
</div>

<div class="editor-side-bar-wrapper-full-width" #editorSideBarFullWidth>
  @if (template && fullscreen) {
    <p-drawer [(visible)]="isSideBarVisible" class="irb-sidebar p-sidebar-full-width p-sidebar-tpl-{{template}}" position="right"
      [class]="{'align-top': fullscreen || slot == 'B' || slot == 'C'}" [modal]="isModal" [closeOnEscape]="false"
      [dismissible]="false" [closable]="false" [baseZIndex]="999" [appendTo]="editorSideBarFullWidth">
      <ng-container *ngTemplateOutlet="editors"></ng-container>
    </p-drawer>
  }
</div>

<ng-template #editors>
  @if (template == 'empty') {

  }
  @if (template == 'portfolio') {
    <irb-editor-portfolio [slot]="slot"></irb-editor-portfolio>
  }
  @if (template == 'account') {
    <irb-editor-account [slot]="slot"></irb-editor-account>
  }
  @if (template == 'model') {
    <irb-editor-model [slot]="slot"></irb-editor-model>
  }
  @if (template == 'blendedModel') {
    <irb-editor-blended-model [slot]="slot"></irb-editor-blended-model>
  }
  @if (template == 'fullRebalance') {
    <irb-editor-full-rebalance [slot]="slot"></irb-editor-full-rebalance>
  }
  @if (template == 'AdjustSecuriritesRebalance') {
    <irb-editor-adjust-securities-rebalance [slot]="slot"></irb-editor-adjust-securities-rebalance>
  }
  @if (template == 'multiplePortfolios') {
    <irb-editor-multiple-portfolios [slot]="slot"></irb-editor-multiple-portfolios>
  }
  @if (template == 'coveredcallRebalance') {
    <irb-editor-coveredcall-rebalance [slot]="slot"></irb-editor-coveredcall-rebalance>
  }
  @if (template == 'editmultipleaccounts') {
    <irb-editor-multiple-account [slot]="slot"></irb-editor-multiple-account>
  }
  @if (template == 'portfolioResultDetail') {
    <irb-editor-portfolio-result [slot]="slot"></irb-editor-portfolio-result>
  }
  @if (template == 'HarvestTaxLossRebalance') {
    <irb-editor-harvest-tax-loss-rebalance [slot]="slot"></irb-editor-harvest-tax-loss-rebalance>
  }
  @if (template == 'generateinvestcashRebalance') {
    <irb-editor-generate-invest-cash-rebalance [slot]="slot"></irb-editor-generate-invest-cash-rebalance>
  }
  @if (template == 'investcashRebalance') {
    <irb-editor-invest-cash-rebalance [slot]="slot"></irb-editor-invest-cash-rebalance>
  }
  @if (template == 'generatecashRebalance') {
    <irb-editor-generate-cash-rebalance [slot]="slot"></irb-editor-generate-cash-rebalance>
  }
  @if (template == 'manualadjustmentRebalance') {
    <irb-editor-manual-adjustment-rebalance [slot]="slot"></irb-editor-manual-adjustment-rebalance>
  }
  @if (template == 'ReplaceSecuritiesRebalance') {
    <irb-editor-replace-securities-rebalance [slot]="slot"></irb-editor-replace-securities-rebalance>
  }
  @if (template == 'editSecurity') {
    <irb-editor-security [slot]="slot"></irb-editor-security>
  }
  @if (template == 'editMultipleSecurity') {
    <irb-editor-multiple-security [slot]="slot"></irb-editor-multiple-security>
  }
  @if (template == 'editTradingInstructions') {
    <irb-edit-trading-instructions [slot]="slot"></irb-edit-trading-instructions>
  }
  @if (template == 'editMMCModel') {
    <irb-editor-mmc-model [slot]="slot"></irb-editor-mmc-model>
  }
  @if (template == 'editMMCAdvisorModel') {
    <irb-editor-mmc-advisor-model [slot]="slot"></irb-editor-mmc-advisor-model>
  }
  @if (template == 'TlhFullRebalance') {
    <irb-editor-tlh-full-rebalance [slot]="slot"></irb-editor-tlh-full-rebalance>
  }
  @if (template == 'quickOrderEntry') {
    <irb-editor-quick-order-entry [slot]="slot"></irb-editor-quick-order-entry>
  }
</ng-template>
